import withOthersNotSelected from "../../assets/images/svg/withOthersNotSelected.svg";
import nuvamaSelected from "../../assets/images/svg/nuvamaSelected.svg";
import withOtherSelected from "../../assets/images/svg/withOtherSelected.svg";
import nuvamaNotSelected from "../../assets/images/svg/nuvamaNotSelected.svg";
import { observer, Observer } from "mobx-react";
import { useEffect } from "react";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";

const SettingInvestment = ({ handleWealth }) => {
  useEffect(() => {
    AuthStore.updateLoadingFullScreen(false);
    // eslint-disable-next-line
  }, [SettingsStore.investmentHeldWith]);

  const getSelectedState = ({ type }) => {
    return type === "nuvama" || SettingsStore.isheldaway
      ? { cursor: "pointer" }
      : { cursor: "not-allowed" };
  };

  const Filter = ({
    type,
    investmentHeldWith,
    selectedImage,
    notSelectedImage,
  }) => {
    const getSrc = ({
      type,
      investmentHeldWith,
      selectedState,
      notSelectedState,
    }) => {
      if (SettingsStore.isheldaway) {
        return investmentHeldWith.includes(SettingsStore.investmentHeldWith)
          ? selectedState
          : notSelectedState;
      } else return type === "nuvama" ? selectedState : notSelectedState;
    };

    return (
      <>
        <div
          style={getSelectedState({ type })}
          className={`with_nuvama ${
            getSrc({
              type,
              investmentHeldWith,
              selectedState: true,
              notSelectedState: false,
            })
              ? "active"
              : ""
          }`}
          onClick={() => {
            if (SettingsStore.isheldaway) {
              handleWealth(type);
            }
          }}
        >
          <div className="logo" style={getSelectedState({ type })}>
            <img
              src={getSrc({
                type,
                investmentHeldWith,
                selectedState: selectedImage,
                notSelectedState: notSelectedImage,
              })}
              alt="With_nuvama"
            />
          </div>
          <div className="title1">{type}</div>
        </div>
      </>
    );
  };

  return (
    <Observer>
      {() => (
        <div className="investments_held_with">
          <div className="nuvama_selector_main">
            <Filter
              type="nuvama"
              investmentHeldWith={["0", "1", null]}
              selectedImage={nuvamaSelected}
              notSelectedImage={nuvamaNotSelected}
            />
            <Filter
              type="others"
              investmentHeldWith={["0", "2", null]}
              selectedImage={withOtherSelected}
              notSelectedImage={withOthersNotSelected}
            />
          </div>
          <div className="investments_held_with_bottom_text blueTextColor">
            Other advisor option will only be enabled if you provide us with
            portfolio information held outside Nuvama
          </div>
        </div>
      )}
    </Observer>
  );
};

export default observer(SettingInvestment);
